import { BadgeResponse, BadgesModel } from 'app/gamma/src/types';
import genericNormalizer, { normalizeDate } from './generic';

export const normalizeBadges = genericNormalizer<BadgeResponse, BadgesModel>(
  ({ from, has }) => ({
    attachments: from('attachments'),
    attachmentsByType: from('attachmentsByType'),
    checklistItems: from('checkItems'),
    checklistItemsChecked: from('checkItemsChecked'),
    comments: from('comments'),
    description: from('description'),
    due: has('due', normalizeDate),
    dueComplete: from('dueComplete'),
    subscribed: from('subscribed'),
    viewingMemberVoted: from('viewingMemberVoted'),
    votes: from('votes'),
  }),
);
